export const environment = {
  production: false,
  apiUrl: 'https://saas-api-dev.cristaliapro.com.br/api',
};